__turbopack_context__.v({
  "fhs": "styles-module-scss-module__0FdXdG__fhs",
  "fhs__content": "styles-module-scss-module__0FdXdG__fhs__content",
  "fhs__main": "styles-module-scss-module__0FdXdG__fhs__main",
  "fhs__main_header": "styles-module-scss-module__0FdXdG__fhs__main_header",
  "fhs__panel": "styles-module-scss-module__0FdXdG__fhs__panel",
});
